

import { ActionT, LOG_OUT, SOCKET_CONNECT, SOCKET_CONNECTED, SOCKET_DISCONNECT, SOCKET_EMIT, SOCKET_ON } from "../actions/actionsType";


import { instanceSocketClient, SocketListeners } from '../../service/InstanceSocketClient';

export interface SocketStateT {
    isReady: boolean
    isConnected: boolean
    statusSocket: string
    socketToken: string
    socket: any
    event: string
    args: any
};

const InitData: SocketStateT = {
    isReady: false,
    isConnected: false,
    socketToken: null,
    statusSocket: "init",
    socket: null,
    event: "",
    args: {},
};
export function socket(state: SocketStateT = InitData, action: ActionT): SocketStateT {

    switch (action.type) {
        case SOCKET_CONNECT:

            instanceSocketClient.init("", action.payload.token)
            /**
             * start listeners event socket
             */
            SocketListeners(instanceSocketClient.socket)

            return {
                ...state,
                isReady: true,
                statusSocket: "connect",
                socketToken: action.payload.token,
                socket: instanceSocketClient.socket,
            };
        case SOCKET_CONNECTED:
            return {
                ...state,
                isConnected: true,
            }

        case SOCKET_DISCONNECT:
            return {
                ...state,
                isConnected: false,
            }
        case SOCKET_ON:
            return {
                ...state,
                event: action.payload.event,
                args: action.payload.args
            }
        case SOCKET_EMIT:
            instanceSocketClient.emit(action.payload.event, action.payload.args)
            return {
                ...state,
                event: action.payload.event
            }
        case LOG_OUT:
            instanceSocketClient.close()
            return {
                ...state,
                socketToken: null,
                isReady: false,
            }
        default:
            return state;
    }
}

export default socket;


